import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import {
  modifyQuantityEvent,
  removeFromCartEvent
} from 'events/cart';

import {
  cartError,
  changeQuantity,
  fetchCartItems
} from 'actions/cart';
import SessionRequired from 'components/common/SessionRequired';
import { translateCartError } from 'apis/mafia';

const maxQuantity = 10;

export const makeOptions = (onHand, currentVal) => {
  /* if we have a ton on hand, just set to 10 */
  if (onHand > maxQuantity) {
    onHand = maxQuantity;
  }

  const options = [];

  for (let i = 1; i <= onHand; i++) {
    options.push(<option key={i} value={i}>{i}</option>);
  }

  if (currentVal > onHand) {
    options.push(<option disabled key={currentVal} value={currentVal}>{currentVal}</option>);
  }

  return options;
};

export class CartQuantityDropdown extends Component {
  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object
  };

  static defaultProps = {
    onChangeQuantity: f => f
  };

  state = { isDeleting: false }

  onChangeQuantity = ({ currentTarget }) => {
    const {
      changeQuantity,
      cartError,
      fetchCartItems,
      onChangeQuantityCb,
      onChangeQuantityCbDone,
      removeFromCartEvent,
      modifyQuantityEvent
    } = this.props;

    const {
      dataset: { asin, cartitemid, isEgc },
      value: quantity
    } = currentTarget;

    onChangeQuantityCb(asin);

    if (+quantity === 0) {
      this.setState({ isDeleting: true });
      removeFromCartEvent(asin);
    } else {
      modifyQuantityEvent(quantity, asin);
    }

    const itemData = { asin, quantity };

    if (isEgc === 'true' && cartitemid) {
      itemData.itemType = 'egc';
      itemData.cartItemId = cartitemid;
    }

    changeQuantity({ 'items': [itemData] }).then(response => {
      !!+quantity && onChangeQuantityCbDone();

      // TODO: remove this logic once https://github01.zappos.net/mweb/marty/issues/6291 is addressed on the mafia side
      if (+quantity === 0 && isEgc === 'true') {
        fetchCartItems();
      }

      const error = translateCartError(response);

      if (error) {
        cartError(error);
      }
    });
  }

  makeJanusPixel = item => {
    const {
      p13nPixelUrl,
      origin
    } = this.props;

    const { pathname, search } = window.location;

    const {
      stockId,
      styleId
    } = item;

    const qs = queryString.stringify({
      teen: styleId,
      child: stockId,
      widget: 'DeleteCart',
      referer: `${origin}${pathname}${search}`
    });

    return (
      <SessionRequired>
        <img
          alt=""
          src={`${p13nPixelUrl}?${qs}`}/>
      </SessionRequired>
    );
  }

  render() {
    const { item } = this.props;
    const { testId, marketplace: { cart: { allowAdjustQuantity } } } = this.context;
    const { isDeleting } = this.state;

    const {
      egc,
      asin,
      quantity,
      stock,
      onHand,
      cartItemId
    } = item;

    // if item is an egc, item is out of stock, or item does not allow quantity adjustments
    if (egc || !stock || !allowAdjustQuantity) {
      return (
        <button
          data-asin={asin}
          data-is-egc={egc}
          data-cartitemid={cartItemId}
          value={0}
          data-test-id={testId('removeButton')}
          onClick={this.onChangeQuantity}>Remove</button>
      );
    }

    return (
      <>
        <label id={`quantity-${asin}`} htmlFor="quantity" data-test-id={testId('quantityDropdownLabel')}>Quantity</label>
        <select
          id={`quantity-${asin}`}
          data-asin={asin}
          value={quantity}
          onChange={this.onChangeQuantity}
          data-test-id={testId('quantityDropdown')}
          name="quantity">
          <option value={0}>Remove</option>
          { makeOptions(onHand, item.quantity) }
        </select>
        { isDeleting && this.makeJanusPixel(item) }
      </>
    );
  }
}

export function mapStateToProps(state) {
  const { cart } = state;
  return {
    cart,
    origin: state.environmentConfig.canonical.url,
    p13nPixelUrl: `${state.environmentConfig.api.mafia.url}/janus/recos/bi/ingest/pixel.png`
  };
}

export default connect(mapStateToProps, {
  cartError,
  changeQuantity,
  fetchCartItems,
  modifyQuantityEvent,
  removeFromCartEvent
})(CartQuantityDropdown);
